import { createContext } from 'react'

import type { FeatureToggleContextType } from './types'

export const FeatureToggleContext = createContext<FeatureToggleContextType | undefined>(undefined)
